import React from 'react';

export { default as OnboardingFlow } from './OnboardingFlow';

export const WelcomeScreen = React.lazy(() => import('./WelcomeScreen'));
